export default "__VITE_ASSET__B4Aop0LO__"